import { Pricing, withModal } from 'components/Modal';
import { isFunction } from 'lodash';
import React from 'react';
import { Route } from 'react-router-dom';
import { compose, withPropsOnChange } from 'recompose';

const load = (promise) => {
  let component;
  class LoadComponent extends React.Component<any, any> {
    state = {
      isLoaded: !!component,
    };

    componentWillMount() {
      if (!!component) return;
      const p = isFunction(promise) ? promise() : promise;
      p.then((response) => {
        component = React.createFactory(response.default);
        this.setState({ isLoaded: true });
      });
    }

    render() {
      const { isLoaded } = this.state;
      return isLoaded && component(this.props);
    }
  }

  return withModal('pricing', Pricing)(LoadComponent);
};

export default compose<any, any>(
  withPropsOnChange(['component'], ({ component }) => ({
    component:
      isFunction(component) || component instanceof Promise
        ? load(component)
        : component,
  }))
)(Route);

interface IPage extends Route {
  component?: React.Component<any, any> | Promise<string>;
}
